const isLocal =
  process.env.REACT_APP_HOST_LOCAL &&
  window.location.host.includes(process.env.REACT_APP_HOST_LOCAL);

const isXVote =
  process.env.REACT_APP_XVOTE_HOST &&
  window.location.host.includes(process.env.REACT_APP_XVOTE_HOST);

const isDploy = window.location.host === 'app.sei.dploy.com.br';

let host;
let urlApi;

if (isLocal) {
  host = 'dev.votando.com.br';
  // urlApi = process.env.REACT_APP_API_URL;
  // urlApi = 'https://services.sei.dploy.com.br/api/v1';
  urlApi = 'https://services.production.votando.com.br/api/v1';
} else if (isXVote) {
  host = window.location.host;
  urlApi = process.env.REACT_APP_XVOTE_API_URL;
} else if (isDploy) {
  host = window.location.host;
  urlApi = 'https://services.sei.dploy.com.br/api/v1';
} else {
  host = window.location.host;
  urlApi = process.env.REACT_APP_API_URL;
}

export const getUrlApi = () => {
  return urlApi;
};

export const getUrlShareReceipt = (
  voteUuid: string,
  locale: string,
  userId: string
): string => {
  const uri = getUrlApi().replace('api/v1', 'receipt');
  return `${uri}/${voteUuid}?locale=${locale}&v=${userId}`;
};

export const getHost = () => {
  return host;
};



// WEBPACK FOOTER //
// ./src/shared/helpers/getApiFromLocation.ts